import React from 'react';
import { BookOpen, ExternalLink } from 'lucide-react';
import { AMAZON_CONFIG, getAmazonSearchUrl } from '@/config/monetization';

const AmazonBooks = ({ keywords, title = "Leituras Recomendadas" }) => {
  // Extract main keywords from the call's knowledge areas or title
  const searchTerms = keywords
    .slice(0, 3)
    .join(' ')
    .replace(/[^\w\sáéíóúàèìòùãõâêîôûç]/gi, '')
    .trim();

  if (!searchTerms || !AMAZON_CONFIG.ENABLED) return null;

  const amazonSearchUrl = getAmazonSearchUrl(searchTerms);

  // Suggested search variations based on common academic areas
  const getSpecificSearches = () => {
    const searches = [];
    const lowerKeywords = keywords.map(k => k.toLowerCase()).join(' ');

    if (lowerKeywords.includes('sociologia') || lowerKeywords.includes('sociais')) {
      searches.push({ term: 'sociologia brasileira', label: 'Sociologia' });
    }
    if (lowerKeywords.includes('educação') || lowerKeywords.includes('ensino')) {
      searches.push({ term: 'educação pesquisa acadêmica', label: 'Educação' });
    }
    if (lowerKeywords.includes('saúde') || lowerKeywords.includes('medicina')) {
      searches.push({ term: 'pesquisa saúde pública', label: 'Saúde' });
    }
    if (lowerKeywords.includes('engenharia')) {
      searches.push({ term: 'engenharia livro técnico', label: 'Engenharia' });
    }
    if (lowerKeywords.includes('direito') || lowerKeywords.includes('jurídic')) {
      searches.push({ term: 'direito brasileiro', label: 'Direito' });
    }
    if (lowerKeywords.includes('psicologia')) {
      searches.push({ term: 'psicologia científica', label: 'Psicologia' });
    }
    if (lowerKeywords.includes('administração') || lowerKeywords.includes('gestão')) {
      searches.push({ term: 'administração gestão', label: 'Administração' });
    }
    if (lowerKeywords.includes('história')) {
      searches.push({ term: 'história brasil', label: 'História' });
    }
    if (lowerKeywords.includes('comunicação') || lowerKeywords.includes('mídia')) {
      searches.push({ term: 'comunicação mídia', label: 'Comunicação' });
    }
    if (lowerKeywords.includes('ambiental') || lowerKeywords.includes('meio ambiente')) {
      searches.push({ term: 'meio ambiente sustentabilidade', label: 'Meio Ambiente' });
    }
    if (lowerKeywords.includes('computação') || lowerKeywords.includes('informática')) {
      searches.push({ term: 'computação programação', label: 'Computação' });
    }
    if (lowerKeywords.includes('biológ') || lowerKeywords.includes('biologia')) {
      searches.push({ term: 'biologia ciências', label: 'Biologia' });
    }
    if (lowerKeywords.includes('economia') || lowerKeywords.includes('econômic')) {
      searches.push({ term: 'economia brasileira', label: 'Economia' });
    }
    if (lowerKeywords.includes('letras') || lowerKeywords.includes('literatura')) {
      searches.push({ term: 'literatura brasileira', label: 'Literatura' });
    }
    if (lowerKeywords.includes('física')) {
      searches.push({ term: 'física livro universitário', label: 'Física' });
    }
    if (lowerKeywords.includes('química')) {
      searches.push({ term: 'química livro universitário', label: 'Química' });
    }
    if (lowerKeywords.includes('matemática') || lowerKeywords.includes('estatística')) {
      searches.push({ term: 'matemática estatística', label: 'Matemática' });
    }

    // Always add a methodology book suggestion for researchers
    if (searches.length < 3) {
      searches.push({ term: 'metodologia pesquisa científica', label: 'Metodologia' });
    }

    return searches.slice(0, 3);
  };

  const specificSearches = getSpecificSearches();

  return (
    <div className="mt-4 p-4 bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-lg">
      <div className="flex items-center gap-2 mb-3">
        <BookOpen className="h-4 w-4 text-amber-700" />
        <h4 className="font-semibold text-amber-900 text-sm">{title}</h4>
        <span className="text-xs text-amber-600 ml-auto">Parceiro Amazon</span>
      </div>
      
      <div className="flex flex-wrap gap-2">
        {specificSearches.map((search, idx) => (
          <a
            key={idx}
            href={getAmazonSearchUrl(search.term)}
            target="_blank"
            rel="noopener noreferrer sponsored"
            className="inline-flex items-center gap-1 px-3 py-1.5 bg-white border border-amber-300 rounded-full text-xs font-medium text-amber-800 hover:bg-amber-100 hover:border-amber-400 transition-colors"
          >
            {search.label}
            <ExternalLink className="h-3 w-3" />
          </a>
        ))}
      </div>

      <a
        href={amazonSearchUrl}
        target="_blank"
        rel="noopener noreferrer sponsored"
        className="mt-3 inline-flex items-center gap-1 text-xs text-amber-700 hover:text-amber-900 hover:underline"
      >
        Ver todos os livros relacionados na Amazon →
      </a>
    </div>
  );
};

export default AmazonBooks;
